export const Resultcontent = [
  {
    id: 0,
    rating: "4.44(192)",
    img: "./card_1.jpg",
    styles: "bigcontents__list1",
    title: "Jagannath Temple, The Abode Of The Lord of Odisha ",
    type: "Religious Place",
    location: "Puri",
    host: "Mike",
    amenities: "",
    // smalldescription: "3 guests · 1 bedroom · 1 bed · 1 bath",
     price: "₹26,466/person",
    description:
      "The Jagannath Temple is an important Hindu temple dedicated to Jagannath, a form of Vishnu one of the trinity of supreme divinity in Hinduism. Puri is in the state of Odisha, on the eastern coast of India. The present temple was rebuilt from the tenth century onwards, on the site of pre-existing temples in the compound but not the main Jagannatha temple, and begun by Anantavarman Chodaganga, the first king of the Eastern Ganga dynasty.",
  },
  {
    id: 1,
    img: "./card_2.jpg",
    rating: "4.75(102)",
    title: "National Park",
    type: "national park",
    location: "bhubaneshwar",
    host: "Abod",
    // amenities: "Wifi · Washer · kitchen",
  //  smalldescription: "4 guests · 2 bedrooms · 0 beds · 1 bat/h",
    price: "₹26906/person",
    description:
      "Amidst the natural beauty of natural forest adjacent to Chandaka-Dampara Wildlife Sanctuary, Nandankanan lies in the vicinity of Kanjia lake. This site covers a portion of Krishnanagar and Jujhagarh Demarcated Protected Forests (DPF) and close to Baranga Railway station on Howrah-Chennai route.",
  },
  {
    id: 2,
    img: "./card_3.jpg",
    rating: "New",
    title: "Eco Retreat, Konark",
    type: "Luxury spots",
    location: "Konark",
    host: "Micheal",
    // amenities: "Wifi · Washer · kitchen",
  //  smalldescription: "1 guest · 1 bedroom · 1 bed · 1 shared bath",
    price: "₹26896/person",
    description:
      "The luxurious glamping event on the Ramchandi beach is a perfect escapade for solitude seekers. A leisurely drive along the Puri-Konark marine drive & visiting heritage monument Konark temple would be an enchanting experience.",
  },
  {
    id: 3,
    img: "./card_4.jpg",
    rating: "4.15(35)",
    title: "Bhubaneshwar Tour Package",
    type: "Sight seeing places",
    location: "Bhubaneshwar",
    host: "Abod Mike",
    // amenities: "Wifi · Washer · iron",
  //  smalldescription: "2 guests · 1 bedroom · 1 bed · 1 private bath",
    price: "₹20000/person",
    description:
      "Bhubaneswar, the capital of Odisha, lies in its coastal region, though not on the coast. It is located on the banks of the River Kuakhai which is part of the delta of the Mahanadi river. Together with Konark and Puri, it forms the Swarna Tribhuja or Golden Triangle of Odisha tourism. This city makes an ideal starting point for the traveller who wishes to explore the magnificence of Kalinga architecture, worship at its grand temples or enjoy the beaches of Puri."
  },
  {
    id: 4,
    img: "./card_5.jpg",
    rating: "3.75(162)",
    title: "Barunei Hills",
    type: "Explore hills ",
    location: "Odisha",
    host: "Toju",
    // amenities: "Wifi · Washer · kitchen",
  //  smalldescription: "3 guests · 1 bedroom · 1 bed · 1 bath",
    price: "₹15566/person",
    description:
      "Maa Barunei temple and Karunei Pitha is situated at the bottom of Barunei hills. It is only 5 km distance from Khordha towards east and south nearby the National Highway No 5. Maa Barunei is one of the presiding deities of Khorda. This is also known as a Shaktipitha in Odisha. The temple was built by Ramachandra Dev. The gurgling water stream is flowing which is called Swarga Ganga. Besides this some mangroves seen here for attraction to the visitors. The main Prasad of Devi Barunei is rice pudding. Maa Barunei mandir is a famous temple in Khordha District. Rajo Sankranti is a famous festival for the temple and during that time a fair is held here for three days which many people come here to enjoy.",
  },
  {
    id: 5,
    img: "./card_6.jpg",
    rating: "4.55(155)",
    title: "Konark Sun Temple",
    type: "Historical Monnuments",
    location: "Konark",
    host: "abod micheal",
    // amenities: "Wifi · Washer · kitchen",
  //  smalldescription: "2 guests · 1 bedroom · 0 beds · 1 bath",
    price: "₹11112/person",
    description:
      "Konark is a medium town in the Puri district in the state of Odisha, India. It lies on the coast by the Bay of Bengal, 65 kilometres from the capital of the state, Bhubaneswar.It is the site of the 13th-century Sun Temple, also known as the Black Pagoda, built in black granite during the reign of Narasinghadeva-I. The temple is a World Heritage Site.The temple is now mostly in ruins, and a collection of its sculptures is housed in the Sun Temple Museum, which is run by the Archaeological Survey of India.",
  },
  {
    id: 6,
    img: "./card_7.jpg",
    rating: "4.25(425)",
    title: "Deras Dam",
    type: "Dam",
    location: "Odisha",
    host: "Mike Abod",
    // amenities: "Wifi · Washer · kitchen",
    //smalldescription: "2 guests · 1 bedroom · 1 bed · 1 bath",
    price: "₹12466/person",
    description:
      "It is 3rd largest dam in orissa which was built for irrigation purpose and for elephants in the Chandaka Elephant sanctuary.One of the hotspot for picnic and oriya film industry.",
  },
  {
    id: 7,
    img: "./card_8.jpg",
    rating: "4.44(444)",
    title: "Tapang Green Lake",
    type: "Lake",
    location: "Nijigarh",
    host: "Abod",
    // amenities: "Wifi · Washer · iron",
   // smalldescription: "4 guests · 1 bedroom · 2 beds · 1 private bath",
    price: "₹9000/person",
    description:
      "Tapang Green Lake is located at Nijigarh in Khordha District. It is 12 km from Khordha town and 37 Km from Bhubaneswar. Bada Sauli Mundia is known as Odisha Canyon Lake. The artificial Lake was created after the mining of stone mines. The reflection of the sun's rays on the green waters of Lake Tapang is wonderful. With its beautiful sight near the city of Bhubaneswar, it has become a tourist destination for both state and foreign tourists in a very short time. the best time to visit this place is during sunrise or sunset because you can enjoy feeling the charm.",
  },
];

export const Maincontents = [
  {
    id: 8,
    img: "./card__1.jpg",
    title: "Eco Retreat Odisha ",
    description: "Watch the sea toss and turn, find a moment to yourself as the wave’s crash against time!",
  },
  {
    id: 9,
    img: "./card__2.jpg",
    title: "Konark",
    description:
      "Imposing structures and skilful craftsmanship transcends time & captures your imagination.",
  },
  {
    id: 10,
    img: "./card__3.jpg",
    title: "Bhitarkanika National Park",
    description: "Reunite with yourself & let the wilderness take you home.",
  },
];

export const Bigcontents = [
  {
    id: 11,
    img: "./main-card_1.jpg",
    styles: "bigcontents__list1",
    description: "Decode the science of 2020 with Bill Nye",
  },
  {
    id: 12,
    img: "./main-card_2.jpg",
    description: "Go on a leopard safari in Sri Lanka ",
  },
  {
    id: 13,
    img: "./main-card_3.jpg",
    styles: "bigcontents__list3",
    description: "Discover Buenos Aires street art and sketch",
  },
];

export const Content = [
  {
    id: 0,
    img: "./card_1.jpg",
    styles: "bigcontents__list1",
    title: "Holy Trip to Odisha (Jagannath Temple Tour)",
    price: "₹26,466/person",
    description: "One of the trinity of supreme divinity in Hinduism",
  },
  {
    id: 1,
    img: "./card_2.jpg",
    title: "Nandankanan National Park",
    price: "₹12,369/person",
    description: "Explore the wild world in the national parks and sanctuaries of Odisha",
  },
  {
    id: 2,
    img: "./card_3.jpg",
    title: "Eco Retreat Konark",
    styles: "bigcontents__list3",
    price: "₹30,000/person",
    description:
      "The luxurious glaming sightseeing on the Ramchandi beach for solitude seekers",
  },
  {
    id: 3,
    img: "./card_4.jpg",
    styles: "bigcontents__list4",
    title: "Sweet Escapade to Bhubaneshwar",
    price: "₹25,000/person",
    description: "Visit The Land Of Beautiful Architecture ",
  },
  
];

export const Contentt = [
  {
    id: 4,
    img: "./card_5.jpg",
    styles: "bigcontents__list1",
    title: "Barunei Hills  ",
    price: "₹5000/person",
    description: "Nestled among the Capital City, this hill station is a treat for nature lovers ",
  },
  {
    id: 5,
    img: "./card_6.jpg",
    title: "Konark's Sun Temple",
    price: "₹12000/person",
    description: "The temple at Konarak is an epic representation of the sun god Surya's chariot",
  },
  {
    id: 6,
    img: "./card_7.jpg",
    title: "Deras Dam",
    styles: "bigcontents__list3",
    price: "₹8000/person",
    description:
      "A Tour to Deras Dam will refresh your spirits in such a beautiful surrounding.",
  },
  {
    id: 7,
    img: "./card_8.jpg",
    styles: "bigcontents__list4",
    title: "Tapang Lake",
    price: "₹6,500/person",
    description: "Tapang Green Lake is located at 37 Km from Bhubaneswar",
  },
  
];
